import { Component, Input } from '@angular/core';

@Component({
  selector: 'brn-checkmark',
  templateUrl: './checkmark.component.html',
  styleUrls: ['./checkmark.component.scss'],
})
export class CheckmarkComponent {
  @Input() checked!: boolean;
  @Input() name!: string;
  @Input() error!: boolean;
  constructor() {}
}
